










































import Vue from 'vue';
import { Portal } from '@linusborg/vue-simple-portal';
import CloseIcon from '@/assets/close.svg';
import { getFocusableElement } from '@/utils/get-focusable-element';
import { ComponentOptionsWithScopeId, ComponentScopeAttrs } from '@/models/common';

const CLASS_NAME = 'modal';
const DEFAULT_TRANSITION = 'fade';

interface Data {
  visible: boolean;
}

export default Vue.extend({
  name: 'AModal',
  components: {
    Portal,
    CloseIcon,
  },
  props: {
    contentClass: { type: String, default: '' },
    hideCloseButton: Boolean,
    transition: { type: String, default: DEFAULT_TRANSITION },
  },
  data(): Data {
    return {
      visible: true,
    };
  },
  computed: {
    className(): typeof CLASS_NAME {
      return CLASS_NAME;
    },
    // see https://github.com/LinusBorg/portal-vue/issues/263
    scopeAttrs(): ComponentScopeAttrs {
      const scopeAttr = (this.$vnode.context?.$options as ComponentOptionsWithScopeId)._scopeId;
      return scopeAttr ? { [scopeAttr]: '' } : null;
    },
  },
  mounted() {
    this.$nextTick(() => this.focusIn(this.$refs.modal as HTMLElement));
  },
  methods: {
    close(): void {
      this.visible = false;
    },
    emitClose(): void {
      const modalElements = document.getElementsByClassName(this.className);
      const currentModalElement = modalElements[modalElements.length - 2] as HTMLElement | undefined;

      this.$emit('close');

      if (currentModalElement) {
        this.$nextTick(() => this.focusIn(currentModalElement));
      }
    },
    focusIn(modalElement: HTMLElement): void {
      const focusableElement = getFocusableElement(modalElement);

      if (focusableElement) {
        focusableElement.focus();
      } else {
        modalElement.focus();
      }
    },
  },
});
